import React from 'react';
import {Switch, Route} from "react-router-dom";
import CaseList from './list';
import CaseAdd from './add';

export default () => <Switch>
    <Route path="/cases/add"><CaseAdd/></Route>
    <Route path="/cases"><CaseList/></Route>
</Switch>
